<template>
  <div class="template1">
    <link rel="stylesheet" href="css/CarrazaHuezo.css" />
    <br>
    <img id="logo"
      src="https://firebasestorage.googleapis.com/v0/b/swanmoments-f3801.appspot.com/o/Boda%20Aviles%20Membre%C3%B1o%2Flogo.svg?alt=media&token=377799d4-e703-4e1b-ac6f-d7d99e34699b"
      alt="" />
    <GrandDay :Code="Code" />
    <MusicPlayer />
    <InfoEvent :Code="Code" />
    <GitfTable :Code="Code" />
    <RSVP :Code="Code" />
    <img id="LogoFinal"
      src="https://firebasestorage.googleapis.com/v0/b/swanmoments-f3801.appspot.com/o/Boda%20Aviles%20Membre%C3%B1o%2FFINAL.svg?alt=media&token=2f318b12-60be-40e9-aa01-e6fc55a5b3c2"
      alt="" />
      <div style="width: 100%; height: 2.5rem; background-color: #65705A;"></div>
  </div>
</template>
  
<script>
import GrandDay from '../Template1/GrandDay.vue';
import MusicPlayer from '../Template1/MusicPlayer.vue';
import InfoEvent from '../Template1/InfoEvent.vue';
import GitfTable from '../Template1/GitfTable.vue';
import RSVP from '../Template1/RSVP.vue';

export default {
  props: {
    Code: {
      type: String,
      required: true,
    },
  },
  components: {
    GrandDay,
    MusicPlayer,
    InfoEvent,
    GitfTable,
    RSVP
  },
};
</script>
  
<style scoped>
.template1 {
  display: grid;
  grid-template-columns: 1fr;
  grid-column-gap: 0px;
  grid-row-gap: 1rem;
  justify-items: center;
  background: var(--bg);
  background-repeat: no-repeat;
  background-size: cover;
  color: var(--text);
}

.template1>#logo {
  width: 20rem;
}


.template1>#programa {
  width: 30rem;
}

h2 {
  font-family: var(--titulos);
  color: var(--title);
  font-size: 2rem;
}

.template1>#programa {
  width: 30rem;
}

#banner {
  width: 45rem;
}

#intinerario {
  width: 40%;
}

.buttons {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: repeat(3, 1fr);
  grid-column-gap: 0px;
  grid-row-gap: 10px;
  height: 100%;
}

#final {
  width: 40%;
}

#LogoFinal{
  width: 35rem;
}
@media (max-width: 768px) {

  #LogoFinal{
  width: 20rem;
}
  .template1>#logo {
    width: 45%;
  }

  .template1>#programa {
    width: 95%;
  }

  #banner {
    width: 100%;
  }

  #intinerario {
    width: 100%;
  }

  #final {
    width: 100%;
  }
}</style>
  